import { Stack, Typography, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";

type Props = {
	icon: LucideIcon;
	iconColor: string;
	label: string;
};

export const FinancialBalanceRowLabel: FC<Props> = ({
	icon: Icon,
	iconColor,
	label,
}) => {
	const theme = useTheme();

	return (
		<Stack direction="row" alignItems="center" gap={theme.spacingTokens.sm}>
			<Icon size={theme.iconSize.sm} color={iconColor} aria-hidden />
			<Typography variant="body2" color={theme.palette.grey[600]}>
				{label}
			</Typography>
		</Stack>
	);
};
